import PageSeriesLeaderboard from "pages/ma/series/leaderboard";

const seriesRouters = [
  { path: "/series/:series_id/leaderboard", component: PageSeriesLeaderboard },
];

export default seriesRouters;
